import React from 'react'

import { UserDocumentCategory } from '@/features/admin/user-document-categories/userDocumentCategories.slice'
import { UserDocument } from '../lib/userDocuments.slice'
import { TabCategoryKeys } from '../lib/constants'
import { getDocumentTag } from '../lib/helpers'
import { Badge, BADGE_COLOR_ARRAY } from '@/ui'

interface UserDocumentTagProps {
  category?: UserDocumentCategory
  document: UserDocument
}

export const UserDocumentTag: React.FC<UserDocumentTagProps> = ({
  category,
  document,
}) => {
  const getCategoryColor = (categoryId: number | null) => {
    if (document.documentType === TabCategoryKeys.BANK_STATEMENTS) {
      return 'blue'
    }

    if (!categoryId) {
      return 'gray'
    }

    return BADGE_COLOR_ARRAY[categoryId % BADGE_COLOR_ARRAY.length]
  }

  const color = getCategoryColor(document.userDocumentCategoryId)
  const documentTag = getDocumentTag(document, category)

  if (!documentTag) {
    return null
  }

  return (
    <Badge color={color} variant="secondary">
      {documentTag}
    </Badge>
  )
}
